module.exports = __webpack_public_path__ + "static/img/add-c.42e7e98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add-c.png
// module id = Vik5
// module chunks = 1